module.exports = __webpack_public_path__ + "img/season-1.babd7618.png";